import { settlementOptions } from "../../../lib/constants";
import { unixToPersianDay, unixToPersianTime } from "../../../utils/utils";
import ValueFinder from "../../shared/ValueFinder";

const SettlementsRows = ({ rowData }) => {
  const { settlement, account } = rowData;
  return (
    <div className="w-full grid grid-cols-[.25fr_1fr_1fr_1fr_1fr] align-middle  py-2 whitespace-nowrap bg-neutral-10 rounded-v-lg mt-2 text-neutral-90 px-2  text-title-sm-regular">
      <div className="flex-center  ">{settlement?.id}</div>
      <div className="flex-center ">{account.system_account ? "وندا ولت" : account.iban}</div>
      <td className="flex-center">{settlement.amount.toLocaleString() ?? "-"}</td>
      <td className="text-center align-middle">
        <div>{unixToPersianDay(settlement.creation_time) ?? "-"}</div>
        <div>{unixToPersianTime(settlement.creation_time) ?? "-"}</div>
      </td>

      <td className="flex-center">
        <ValueFinder data={settlementOptions} title={settlement.settlement_state} />
      </td>
    </div>
  );
};

export default SettlementsRows;
